import {
  withTranslation,
} from 'react-i18next';

import RegattaResultDiplomaFieldsView from './RegattaResultDiplomaFieldsView';

const TranslatedComponent = withTranslation()(RegattaResultDiplomaFieldsView);

const Component = TranslatedComponent;

export default Component;
